import React, { useEffect, useRef, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import useState from "react-usestateref";
import Header from "./Header";
import { FcDataConfiguration } from "react-icons/fc";
import CsvDownloader from 'react-csv-downloader';

import "react-toastify/dist/ReactToastify.css";
import { getUserDetails } from "../services/authservices";
import authService from "../services/authservices";
// import ReactApexChart from "react-apexcharts";
import { ToastContainer, toast } from "react-toastify";
import { ScaleLoader } from "react-spinners";
import dayjs from "dayjs";
import Joyride from "react-joyride";
import { useTranslation } from "react-i18next";
import { UserContext } from "../contexts/UserContext";
import i18n from "../translate/i18n";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import BotPopup from "./BotPopup";
import BotstatusPopup from "./BotstatusPopup";

import service from "../services/authservices";
import Stack from "@mui/material/Stack";
import Pagination from "@mui/material/Pagination";
import FromDatePicker from "../Components/FromDatePicker";
import ToDatePicker from "../Components/ToDatePicker";
import { FaFilter } from "react-icons/fa6";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  boxShadow: 24,
};

function Home() {
  const { t } = useTranslation();
  const { i18nextLng } = useContext(UserContext);
  const [currency, setCurrency] = useState("usdt");
  const [network, setNetwork] = useState("BEP20");
  const [transactions, setTransactions] = useState([]);
  const [fuelWallet, setFuelWallet] = useState(0);
  const [isBotStatusActive, setIsBotStatusActive] = useState(false);
  const [addressData, setAddressData] = useState(null);
  const [siteDatacomes, setSiteData] = useState("");
  const [toastVisible, setToastVisible] = useState(false);
  const [botActivatedAt, setBotActivatedAt] = useState(null);
  const [botDeactivatedAt, setBotDeactivatedAt] = useState(null);
  const [planDetails, setPlanDetails] = useState([]);
  const [planDetailsBot, setPlanDetailsBot] = useState([]);
  const [loader, setLoader] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [strategyDetails, setStrategyDetails] = useState("");
  const [userVerifyEmail, setuserVerifyEmail, userVerifyEmailref] = useState(1);
  const [selectedStrategies, setSelectedStrategies] = useState([]);
  const [user, setUser] = useState({
    tfaStatus: 0,
    email: null,
    uid: null,
    referralCode: null,
    referralUrl: null,
    botStatus: "DeActive",
    displayname: null,
    botActivatedAt: null,
    selectedStrategies: [],
    botDeactivatedAt: null,
    country: null,
    isAuthenticated: false,
    exchanges: [],
    botConfig: null,
  });

  const [userConfig, setuserConfig, userConfigref] = useState({
    tfaStatus: 0,
    email: null,
    uid: null,
    referralCode: null,
    referralUrl: null,
    botStatus: "DeActive",
    displayname: null,
    botActivatedAt: null,
    selectedStrategies: [],
    botDeactivatedAt: null,
    country: null,
    isAuthenticated: false,
    exchanges: [],
    botConfig: null,
  });

  const [i18nextLngs, seti18nextLngs] = useState(
    localStorage.getItem("i18nextLng") || "en" || "et" || "fi"
  );
  useEffect(() => {
    if (i18nextLngs === "en") {
      i18n.changeLanguage(i18nextLngs);
      document.documentElement.lang = i18nextLngs;
    }
    setVisibleStartIndex(0);
  }, [i18nextLngs]);

  const [loading, setLoading] = useState(true);
  const [profitloading, setprofitLoading] = useState(true);
  const navigate = useNavigate();
  const [state, setState] = useState({
    series: [
      {
        name: "Annual ROI",
        data: [0], // Initial data with default 0
      },
    ],
    options: {
      chart: {
        type: "area",
        height: 350,
        toolbar: {
          tools: {
            download: false, // Disable the download button
          },
        },
        zoom: {
          enabled: false,
        },
      },

      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth", // Line shape
        width: 2, // Line thickness
        colors: ["#2ebd85"], // Line color: red
      },
      fill: {
        type: "solid", // Background fill type
        colors: ["#1b2a2a"], // Background color: green
      },
      title: {
        text: "",
        align: "left",
      },
      subtitle: {
        text: "",
        align: "left",
      },
      xaxis: {
        categories: ["Start"], // Initial X-axis category
        labels: {
          show: false,
        },
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
      },
      yaxis: {
        min: 0, // Start from 0
        max: 100, // Default maximum range
        labels: {
          show: true,
        },
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
      },
      grid: {
        show: false, // Hide grid lines if desired
      },
      legend: {
        show: false,
      },
    },
  });

  const [run, setRun] = useState(false);
  const [StratagyList, setStratagyList, StratagyListref] = useState([]);
  const [emailPopup, setEmailPopup] = useState(false);
  const [verifyEmailPopup, setVerifyEmailPopup] = useState(false);
  const [selectedStrategiesnew, setSelectedStrategiesnew] = useState([]);

  const [visibleStartIndex, setVisibleStartIndex] = useState(0);
  const cardsToShow = 3;
  const strategyList = StratagyListref.current || [];
  const showLeftArrow = visibleStartIndex > 0;
  const showRightArrow = visibleStartIndex + cardsToShow < strategyList.length;


    const [bottradeHistory, setbottradeHistory] = useState([]);
    const [limitwithadd, setLimitwithadd] = useState(10);
    const [currentPagebtrade, setCurrentPagebtrade] = useState(1);
    const [totalPagesbtrade, setTotalPagesbtrade] = useState(0);
    const [limitbtrade, setLimitbtrade] = useState(5);
    const coinTyperef = useRef(currency);

    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const inputRef = useRef(null);
    const [filterKeyword, setFilterKeyword] = useState("");
  const [CSVfile, SetCSVfile] = useState([]);

    useEffect(() => {
      fetchbottradeHistory(currentPagebtrade, limitbtrade,fromDate,toDate,filterKeyword);
    }, [currentPagebtrade, limitbtrade]);
  
    const handlePageChange = (event, value, eventName) => {
      switch (eventName) {
        case "Bot Trade":
          setCurrentPagebtrade(value);
          break;
        default:
          break;
      }
    };
  const [botLoader,setbotLoader]=useState(true)
  console.log(botLoader,"botLoader")
    const fetchbottradeHistory = async (page, limit) => {
      setbotLoader(true);
      const response = await service.getBottradeHistorywithfilter(page, limit,fromDate,
        toDate,
         filterKeyword);
      if (response.status) {
        setbottradeHistory(response.data);
        setTotalPagesbtrade(Math.ceil(response.total / limit));
         SetCSVfile(response.csvdata)
        setbotLoader(false);
      } else {
        // console.error("Failed to fetch bot history:", response.Message);
        setbotLoader(false);
      }
    };

    const download_csv = () => {
    toast.success('Profit History  Download Successfully.');
  }

  const scrollLeft = () => {
    if (visibleStartIndex > 0) {
      setVisibleStartIndex((prevIndex) => prevIndex - 1);
    }
  };

  const scrollRight = () => {
    if (visibleStartIndex + cardsToShow < strategyList.length) {
      setVisibleStartIndex((prevIndex) => prevIndex + 1);
    }
  };
  const [riskpopupstatus, setriskpopupstatus] = useState(false);

  useEffect(() => {
    checkFirstLogin();
  }, [0]);

  const checkFirstLogin = async () => {
    try {
      const data = await authService.checkFirstLogin();
      if (data.success == true) {
        setriskpopupstatus(data.data);
        console.log(data, "=-=-=get site datas =-=-", data.data);
      }
    } catch (error) {}
  };
  
  // console.log(emailPopup, "emailPopup run", run);
  // useEffect(() => {

  // }, []);

  // useEffect(() => {
  //   if (run) {
  //     console.log("Starting Joyride tour...");
  //   }
  // }, [run]);

  const steps = [
    {
      target: "body", // Makes the first step appear globally
      content: (
        <div>
          <h3>Create Account</h3>
          <p>
            Get started by creating your account in just a few clicks using your
            email.
          </p>
        </div>
      ),
      placement: "center",
      disableBeacon: true, // Starts immediately without a click
      spotlightClicks: false, // Prevents clicking outside
      disableOverlayClose: true, // Prevents skipping by clicking outside
    },
    {
      target: "body", // Add a valid selector for your UI element
      content: (
        <div>
          <h3>Deposit Amount</h3>
          <p>
            Securely fund your wallet with crypto and prepare for automated
            trading.
          </p>
        </div>
      ),
      placement: "center",
      disableBeacon: true, // Starts immediately without a click
      spotlightClicks: false, // Prevents clicking outside
      disableOverlayClose: true,
    },
    {
      target: "body", // Replace with actual class name of the element
      content: (
        <div>
          <h3>Plan Upgrade</h3>
          <p>
            User has the opportunity to renew his plan either for free or for a
            cost.
          </p>
        </div>
      ),
      placement: "center",
      disableBeacon: true, // Starts immediately without a click
      spotlightClicks: false, // Prevents clicking outside
      disableOverlayClose: true,
    },
    {
      target: "body", // Replace with actual class name
      content: (
        <div>
          <h3> Enable Exchange</h3>
          <p>
            Connect your preferred exchange by adding your API and secret keys.
          </p>
        </div>
      ),
      placement: "center",
      disableBeacon: true, // Starts immediately without a click
      spotlightClicks: false, // Prevents clicking outside
      disableOverlayClose: true,
    },
    {
      target: "body", // Replace with actual class name
      content: (
        <div>
          <h3> Activate Bot</h3>
          <p>
            Turn on your trading bot, manage your portfolio, and let it work for
            you.
          </p>
        </div>
      ),
      placement: "center",
      disableBeacon: true, // Starts immediately without a click
      spotlightClicks: false, // Prevents clicking outside
      disableOverlayClose: true,
    },
    {
      target: "body", // Final step
      content: (
        <div>
          <h3>Withdraw Profits</h3>
          <p>
            Seamlessly transfer your profits anytime with a few simple steps.
          </p>
        </div>
      ),
      placement: "center",
      disableBeacon: true, // Starts immediately without a click
      spotlightClicks: false, // Prevents clicking outside
      disableOverlayClose: true,
    },
  ];

  const truncateText = (text, maxLength) => {
    if (!text || typeof text !== "string") {
      return "--";
    }
    if (text.length > maxLength) {
      return text.substring(0, maxLength) + " . . .";
    }
    return text;
  };

  useEffect(() => {
    if (planDetails?.length > 0) {
      setSelectedStrategiesnew(planDetails);
    }
  }, [planDetails]);

  const openModal = (value) => {
    setStrategyDetails(value);
    console.log("strategy value===", value);
    setIsModalOpen(true);
  };
  const handleModalclose = async () => {
    setIsModalOpen(false);
  };

  const fetchUserDetails = async () => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const data = await getUserDetails(token);
        console.log(data, "Home response here ---->>>>>", data.emailStatus);
        if (data && data.status) {
          const userDetails = {
            isAuthenticated: true,
            tfaStatus: data.tfastatus,
            email: data.email,
            displayname: data.displayname,
            country: data.country,
            uid: data.uid,
            referralCode: data.referralCode,
            selectedStrategies: data.selectedStrategies,
            referralUrl: data.referralUrl,
            botStatus: data.botStatus,
            exchanges: data.exchanges,
            botConfig: data.botConfig,
            botActivatedAt: data.botActivatedAt,
            botDeactivatedAt: data.botDeactivatedAt,
          };
          setUser(userDetails);
          setuserConfig(userDetails);
          // setuserVerifyEmail(data.emailStatus);
          // console.log(data, "Home response here ---->>>>>",userVerifyEmailref.current );

          // const token = localStorage.getItem("token");
          // const hasSeenPopup = localStorage.getItem("hasSeenEmailPopup");
          // const userLogin = localStorage.getItem("userlogin");

          // if (userLogin === "true") {
          //   setRun(true);
          // } else {
          //   if (!userDetails?.email || userDetails?.email == "N/A") {
          //     if (token && !hasSeenPopup) {
          //       setEmailPopup(true);
          //       // localStorage.setItem("hasSeenEmailPopup", "true"); // Mark popup as shown
          //     }
          //   } else if (data.emailStatus == 0) {
          //     // If email exists but not verified
          //     setVerifyEmailPopup(true);
          //   }
          // }

          if (data.botConfig != null) {
            if (data.botConfig.lotPercentage != null) {
              console.log("calll 1111");
              setIsBotconfig(false);
              setshowBotPopup(false);
              setIsBotActive(false);
            } else {
              console.log("calll 2222");
              setIsBotconfig(true);
              setshowBotPopup(true);
              setIsBotActive(true);
            }
          } else {
            console.log("calll 3333");
            setIsBotconfig(true);
            setshowBotPopup(true);
            setIsBotActive(true);
          }

          console.log("isBotconfig===", isBotconfigref.current);
          console.log("showBotPopup===", showBotPopupref.current);
        } else {
          setUser({
            isAuthenticated: false,
            tfaStatus: 0,
            email: null,
            uid: null,
            exchanges: [],
            selectedStrategies: [],
            botActivatedAt: null,
            botDeactivatedAt: null,
            referralCode: null,
            referralUrl: null,
            botConfig: null,
          });
          setuserConfig({
            isAuthenticated: false,
            tfaStatus: 0,
            email: null,
            uid: null,
            exchanges: [],
            selectedStrategies: [],
            botActivatedAt: null,
            botDeactivatedAt: null,
            referralCode: null,
            referralUrl: null,
            botConfig: null,
          });
          setIsBotActive(false);
          setIsBotconfig(false);
        }
      } catch (error) {
        setUser({
          isAuthenticated: false,
          tfaStatus: 0,
          email: null,
          uid: null,
          exchanges: [],
          selectedStrategies: [],
          referralCode: null,
          referralUrl: null,
          botActivatedAt: null,
          botDeactivatedAt: null,
          botConfig: null,
        });
        setuserConfig({
          isAuthenticated: false,
          tfaStatus: 0,
          email: null,
          uid: null,
          exchanges: [],
          selectedStrategies: [],
          botActivatedAt: null,
          botDeactivatedAt: null,
          referralCode: null,
          referralUrl: null,
          botConfig: null,
        });
        setIsBotActive(false);
        setIsBotconfig(false);
      }
    } else {
      setUser({
        isAuthenticated: false,
        tfaStatus: 0,
        email: null,
        uid: null,
        referralCode: null,
        selectedStrategies: [],
        referralUrl: null,
        botActivatedAt: null,
        botDeactivatedAt: null,
        botConfig: null,
      });
      setuserConfig({
        isAuthenticated: false,
        tfaStatus: 0,
        email: null,
        uid: null,
        exchanges: [],
        selectedStrategies: [],
        botActivatedAt: null,
        botDeactivatedAt: null,
        referralCode: null,
        referralUrl: null,
        botConfig: null,
      });
      setIsBotActive(false);
      setIsBotconfig(false);
    }
    setLoading(false);
  };

  useEffect(() => {
    let userToken = localStorage.getItem("token");
    if (userToken == null || userToken == "" || userToken == undefined) {
    } else {
      fetchUserDetails();
      getStratagy();
      marketCurrencyList();
      topStrategiesList();
      fetchBalance();
      fetchuserBalance();
    }
  }, [0]);
  const [marketData, setmarketData, marketDataref] = useState([]);
  const [strategies, setStrategies] = useState([]);
  const [strategiesLoader, setStrategiesLoader] = useState([]);
  const [marketLoader, setmarketLoader] = useState(false);

  useEffect(() => {
    let socket;

    const createSocketConnection = () => {
      socket = new WebSocket("ws://localhost:8080");

      socket.onopen = () => {
        console.log("WebSocket connection established");
      };

      socket.onmessage = (event) => {
        const data = JSON.parse(event.data);
        if (data.status) {
          setmarketData((prevData) => {
            return prevData.map((item) =>
              item.symbol === data.data.symbol
                ? { ...item, price: data.data.price, change: data.data.change }
                : item
            );
          });
          //console.log('Market data updated:', data.data);
        } else {
          console.error("Error receiving market data:", data.message);
        }
      };

      socket.onerror = (error) => {
        console.error("WebSocket error:", error);
      };

      socket.onclose = () => {
        console.log("WebSocket connection closed. Reconnecting...");
        setTimeout(createSocketConnection, 5000); // Reconnect after 5 seconds
      };
    };

    createSocketConnection();

    return () => {
      if (socket) socket.close();
    };
  }, []);

  const closePopup = () => {
    setEmailPopup(false);
  };

  const closeVerifyPopup = () => {
    setVerifyEmailPopup(false);
  };

  const proceedToProfile = () => {
    setEmailPopup(false);
    navigate("/profile");
  };

  useEffect(() => {
    getSitedata();
  }, []);

  const getSitedata = async () => {
    try {
      const data = await authService.getsitedata();
      if (data.status == true) {
        setSiteData(data.data);
        console.log(data, "=-=-=get site datas =-=-", data.data);
      }
    } catch (error) {}
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "";

    return `(${date.toLocaleDateString("en-GB")} at ${date.toLocaleTimeString(
      "en-US",
      {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      }
    )})`;
  };

  // Empty dependency array ensures this effect only runs once when the component mounts

  // useEffect(() => {
  //   // Connect to WebSocket server
  //   const ws = new WebSocket("ws://localhost:8080");

  //   ws.onmessage = (event) => {
  //     const { data } = JSON.parse(event.data);

  //     if (data) {
  //       setmarketData(data);
  //     }
  //   };

  //   ws.onerror = (error) => {
  //   };

  //   return () => {
  //     ws.close();
  //   };
  // }, []);

  const marketCurrencyList = async () => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        setmarketLoader(true);
        const data = await authService.marketCurrencyList(token);
        if (data.status) {
          setmarketLoader(false);
          setmarketData(data.data);
        } else {
          setmarketLoader(false);
          setmarketData([]);
        }
      } catch (error) {}
    }
  };
  const topStrategiesList = async () => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        setStrategiesLoader(true);
        const data = await authService.topStrategiesList(token);
        if (data.status) {
          setStrategiesLoader(false);
          setStrategies(data.data);
        } else {
          setStrategiesLoader(false);
          setStrategies([]);
        }
      } catch (error) {}
    }
  };
  const handleCopy = (txID) => {
    if (handleCopy.toastVisible) return;

    handleCopy.toastVisible = true;

    if (handleCopy.timeout) clearTimeout(handleCopy.timeout);

    handleCopy.timeout = setTimeout(() => {
      navigator.clipboard
        .writeText(txID)
        .then(() => {
          toast.success(
            <div className="toast-ml">
              <h4 className="toast-title">Success!</h4>
              <p className="toast-message">
                Transaction ID copied to clipboard!
              </p>
            </div>
          );
        })
        .catch((err) => {
          console.error("Failed to copy text: ", err);
          toast.error(
            <div className="toast-ml">
              <h4 className="toast-title">Error!</h4>
              <p className="toast-message">Failed to copy Transaction ID</p>
            </div>
          );
        })
        .finally(() => {
          setTimeout(() => {
            handleCopy.toastVisible = false;
          }, 2000);
        });
    }, 300);
  };

  const copyToClipboard = (() => {
    let toastVisible = false;
    let timeout = null;

    return (uid) => {
      if (toastVisible) return;
      if (timeout) clearTimeout(timeout);
      timeout = setTimeout(() => {
        navigator.clipboard
          .writeText(uid)
          .then(() => {
            toastVisible = true;
            showsuccessToast("UID copied to clipboard!", {
              onClose: () => {
                toastVisible = false;
              },
            });
          })
          .catch(() => {
            toastVisible = true;
            showerrorToast("Failed to copy UID", {
              onClose: () => {
                toastVisible = false;
              },
            });
          });
      }, 300);
    };
  })();

  const handleFollowStrategy = async (data) => {
    try {
      setLoader(true);
      var obj = {
        action: data.buttonLabel,
        strategyId: data._id,
      };
      const response = await authService.handleFollowStrategy(obj);
      setStratagyLoader(false);
      const message = response.Message?.trim();
      if (message === "Strategy is Followed") {
        showsuccessToast(response.Message);
        getStratagy();
        setLoader(false);
      } else if (message === "Strategy is Unfollowed") {
        console.log(message, "response.Message");
        showsuccessToast(response.Message);
        getStratagy();
        setLoader(false);
      } else {
        showerrorToast(response.Message);
        setLoader(false);
      }
    } catch (err) {
      setLoader(false);
    }
  };

  const showsuccessToast = (message) => {
    if (!toastVisible) {
      setToastVisible(true);
      toast.dismiss();
      toast.success(
        <div className="toast-ml">
          <h4 className="toast-title">Success!</h4>
          <p className="toast-message">{message}</p>
        </div>,
        {
          onClose: () => setToastVisible(false), // Reset toastVisible on close
          autoClose: 3000, // Optional: auto-close after 3 seconds
        }
      );
    }
  };

  const showerrorToast = (message) => {
    if (!toastVisible) {
      setToastVisible(true); // Set toast as visible
      toast.error(
        <div className="toast-ml">
          <h4 className="toast-title">Error!</h4>
          <p className="toast-message">{message}</p>
        </div>,
        {
          onClose: () => setToastVisible(false), // Reset toastVisible on close
          autoClose: 3000, // Optional: auto-close after 3 seconds
        }
      );
    }
  };
  const showerrorToastbot = (message) => {
    if (!toastVisible) {
      setToastVisible(true);
      toast.dismiss();
      toast.error(
        <div className="toast-ml">
          <h4 className="toast-title">Warning!</h4>
          <p className="toast-message">{message}</p>
        </div>,
        {
          onClose: () => setToastVisible(false), // Reset toastVisible on close
          autoClose: 3000, // Optional: auto-close after 3 seconds
        }
      );
    }
  };

  const [StratagyLoader, setStratagyLoader] = useState(false);

  const getStratagy = async (data) => {
    try {
      setLoader(true);
      const token = localStorage.getItem("token");
      const response = await authService.topStratagies(token);
      setStratagyLoader(false);
      if (response.status == true) {
        if (response.data.length > 0) {
          const updatedSeries = response.data.map((options) => {
            // const annualROI = options?.annualROI || 0;
            const annualROI = options?.profit_percentage || 0;
            // console.log(annualROI, "annualROI")
            return {
              name: options.stratagyName || "Annual ROI",
              data: [0, annualROI],
            };
          });

          // console.log("Updated series:", updatedSeries);

          const maxYValue = Math.max(
            100,
            // ...response.data.map((options) => options?.annualROI || 0)
            ...response.data.map((options) => options?.profit_percentage || 0)
          );

          setState((prev) => ({
            ...prev,
            series: updatedSeries,
            options: {
              ...prev.options,
              xaxis: {
                ...prev.options.xaxis,
                categories: ["Start", "End"],
              },
              yaxis: {
                ...prev.options.yaxis,
                min: 0,
                max: Math.ceil(maxYValue / 10) * 10,
              },
            },
          }));
        } else {
          console.log("No data found, using defaults.");
          setState((prev) => ({
            ...prev,
            series: [
              {
                name: "Annual ROI",
                data: [0, 10],
              },
            ],
            options: {
              ...prev.options,
              xaxis: {
                ...prev.options.xaxis,
                categories: ["Start", "Target"],
              },
              yaxis: {
                ...prev.options.yaxis,
                min: 0,
                max: 100,
              },
            },
          }));
        }
        setStratagyList(response.data);
        setLoader(false);
      } else {
        setStratagyList(response.data);
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
    }
  };

  const navigateStratagy = () => {
    navigate("/strategies");
  };

  const getPlanDetails = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      const response = await authService.getPlanDetails(token);
      setLoading(false);

      if (Array.isArray(response.data) && response.data.length > 0) {
        const plan = response.data[0];
        const activeStrategies = plan?.strategies
          ?.replace(" and ", ",")
          .split(",")
          .map((s) => s.trim())
          .filter((s) => s.length > 0);

        setPlanDetails(activeStrategies || []);
        setPlanDetailsBot(response.active_plan || []);
        // if(response.active_plan.length > 0)
        // {
        //   await handleBotUpdate();
        // }
      } else {
        setPlanDetails([]);
        localStorage.setItem("freemiumActivated", false);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching plan details:", error);
      setPlanDetails([]);
    }
  };

  const updateUserBotStatus = async (data) => {
    try {
      if (
        user?.botStatus === "DeActive" &&
        (!user?.selectedStrategies || user.selectedStrategies.length === 0)
      ) {
        showerrorToast(
          "Please select at least one strategy to activate the bot."
        );
        return;
      }

      if (user?.botStatus === "DeActive" || user?.botStatus === "Deactive") {
        console.log("call here=====");
        // if (planDetails && planDetails.length == 0) {
        if (planDetailsBot && planDetailsBot[0].isActive === false) {
          showerrorToastbot("Please upgrade the plan.");
          return;
        }

        if ((!user && !user.exchanges) || user.exchanges.length === 0) {
          showerrorToastbot("You must have at least one exchange connected.");
          return;
        }

        const minBalanceRequired =
          planDetailsBot[0].min_fuel != null
            ? planDetailsBot[0].min_fuel
            : "$10";

        const numericMinBalanceRequired =
          parseFloat(minBalanceRequired.replace("$", "")) || 0;

        const numericFuelWallet = parseFloat(fuelWallet) || 0;

        if (numericFuelWallet < numericMinBalanceRequired) {
          showerrorToastbot(
            `Insufficient credit balance. A minimum of $${numericMinBalanceRequired} is required.`
          );
          return;
        }

        setStratagyLoader(true);

        const obj = {
          action: data,
        };

        const response = await authService.updateUserBotStatus(obj);

        // Reset loader
        setStratagyLoader(false);

        if (response.status) {
          showsuccessToast(response.message);
          setBotActivatedAt(
            response?.botStatus === "Active" ? response.botActivatedAt : null
          );
          setBotDeactivatedAt(
            response?.botStatus === "Deactive"
              ? response.botDeactivatedAt
              : null
          );
        } else {
          showerrorToastbot(response.message);
        }

        // Refresh necessary data
        getStratagy();
        fetchUserDetails();
      } else if (user?.botStatus === "Active" || user?.botStatus === "active") {
        setStratagyLoader(true);

        const obj = {
          action: data,
        };

        const response = await authService.updateUserBotStatus(obj);

        // Reset loader
        setStratagyLoader(false);

        if (response.status) {
          showsuccessToast(response.message);
          setBotActivatedAt(
            response?.botStatus === "Active" ? response.botActivatedAt : null
          );
          setBotDeactivatedAt(
            response?.botStatus === "Deactive"
              ? response.botDeactivatedAt
              : null
          );
        } else {
          showerrorToastbot(response.message);
        }

        // Refresh necessary data
        getStratagy();
        fetchUserDetails();
      }
    } catch (err) {
      setStratagyLoader(false); // Ensure the loader is reset in case of errors
      console.error("Error updating bot status:", err);
      showerrorToast("An error occurred while updating the bot status.");
    }
  };

  const fetchAddressData = async () => {
    try {
      const data = await authService.getUserAddressNetwork(currency, network);
      if (data.status) {
        setAddressData(data.data);
      } else {
        console.log(data.Message);
      }
    } catch (error) {
      console.error("Error fetching address data:", error);
    }
  };

  const fetchTransactions = async () => {
    setLoading(true);
    try {
      const response = await authService.getDepositHistory();
      if (response.status) {
        if (Array.isArray(response.data) && response.data.length > 0) {
          // Filter unique transactions based on transactionId
          const uniqueTransactions = response.data.filter(
            (value, index, self) =>
              index ===
              self.findIndex((t) => t.transactionId === value.transactionId)
          );
          setTransactions(uniqueTransactions);
        } else {
          setTransactions([]);
        }
      } else {
        setTransactions([]);
      }
    } catch (error) {
      console.error("Error fetching transactions:", error);
      setTransactions([]);
      showerrorToast("Failed to load transactions");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    let userToken = localStorage.getItem("token");
    if (userToken == null || userToken == "" || userToken == undefined) {
    } else {
      fetchAddressData();
      fetchTransactions();
    }
  }, [currency, network]);
  useEffect(() => {
    let userToken = localStorage.getItem("token");
    if (userToken == null || userToken == "" || userToken == undefined) {
    } else {
      getPlanDetails();
    }
  }, []);

  const [totalBalance, setTotalBalance, totalBalanceref] = useState(0);
  const [profitData, setProfitdata] = useState(null);
  const [pageLoader, setpageLoader] = useState(true);
  const fetchBalance = async () => {
    try {
      // const response = await authService.getTransactions();
      const response = await authService.getAssets();
      console.log("fetchBalance", response);
      setpageLoader(true);
      if (response.status) {
        setProfitdata(response.profits);
        setprofitLoading(false);
        setpageLoader(false);
      }
    } catch (error) {
      console.error("Error fetching transactions:", error);
    }
  };

  const fetchuserBalance = async () => {
    try {
      const response = await authService.getwalletAssets();
      console.log("getwalletAssets", response);
      setpageLoader(true);
      if (response.status) {
        setTotalBalance(parseFloat(response.totalBalanceUSDT) || 0);
        setFuelWallet(parseFloat(response?.userWalletFuelAmount) || 0);
        setpageLoader(false);
      }
    } catch (error) {
      console.error("Error fetching transactions:", error);
    }
  };

  const handleStrategyClick = async (strategyName) => {
    try {
      if (planDetailsBot.length > 0) {
        const minBalanceRequired =
          planDetailsBot[0].min_fuel != null
            ? planDetailsBot[0].min_fuel
            : "$10";

        const numericMinBalanceRequired =
          parseFloat(minBalanceRequired.replace("$", "")) || 0;

        const numericFuelWallet = parseFloat(fuelWallet) || 0;

        if (numericFuelWallet < numericMinBalanceRequired) {
          showerrorToastbot(
            `Insufficient credit balance. A minimum of $${numericMinBalanceRequired} is required.`
          );
          return;
        }

        const data = await authService.toggleStrategy(strategyName);

        if (data.status === true) {
          setUser((prev) => ({
            ...prev,
            selectedStrategies: data.selectedStrategies,
          }));
          showsuccessToast(data.Message || "Strategy updated successfully");
        } else {
          showerrorToast(data.Message || "Unable to update strategy");
        }
      } else {
        showerrorToast("No active subscription found");
      }
    } catch (error) {
      console.error("Error in handleStrategyClick:", error);
      showerrorToast("Something went wrong. Please try again.");
    }
  };

  const [isBotActive, setIsBotActive, isBotActiveref] = useState(false);
  const [isBotconfig, setIsBotconfig, isBotconfigref] = useState(false);
  const [showBotPopup, setshowBotPopup, showBotPopupref] = useState(false);

  // const handleBotOpen = async () => {
  //   try {

  //       const hasBotConfig =
  //       user?.botConfig &&
  //       Object.keys(user.botConfig).length > 0 &&
  //       user.botConfig.maxLimit &&
  //       user.botConfig.maxOpen &&
  //       user.botConfig.dailyLoss &&
  //       user.botConfig.lotPercentage &&
  //       user.botConfig.selectedOption &&
  //       user.botConfig.pairSelection &&
  //       user.botConfig.pairSelection.length > 0;

  //     if (!hasBotConfig) {
  //       showerrorToast(
  //         "Please complete your bot configuration before activating the bot."
  //       );
  //       setIsBotActive(true);
  //       return;
  //     }

  //     if (user.botStatus === "Active") {
  //       await updateUserBotStatus("DeActive");
  //       setIsBotActive(false);
  //     } else {
  //       await updateUserBotStatus("Active");
  //       setIsBotActive(false);
  //     }

  //     fetchUserDetails();
  //   } catch (error) {
  //     console.error("Error toggling bot status:", error);
  //     showerrorToast("Failed to update bot status.");
  //   }
  // };

  const handleBotOpen = async () => {
    try {
      await fetchUserDetails();

      const hasBotConfig =
        userConfigref.current?.botConfig &&
        Object.keys(userConfigref.current.botConfig).length > 0 &&
        userConfigref.current.botConfig.maxLimit &&
        userConfigref.current.botConfig.maxOpen &&
        userConfigref.current.botConfig.dailyLoss &&
        userConfigref.current.botConfig.lotPercentage &&
        userConfigref.current.botConfig.selectedOption &&
        userConfigref.current.botConfig.pairSelection &&
        userConfigref.current.botConfig.pairSelection.length > 0;

      if (!hasBotConfig) {
        showerrorToast(
          "Please complete your bot configuration before activating the bot."
        );
        setIsBotActive(true);
        return;
      }

      if (userConfigref.current.botStatus === "Active") {
        await updateUserBotStatus("DeActive");
        setIsBotActive(false);
      } else {
        await updateUserBotStatus("Active");
        setIsBotActive(false);
      }

      // fetchUserDetails();
    } catch (error) {
      console.error("Error toggling bot status:", error);
      showerrorToast("Failed to update bot status.");
    }
  };

  const handleBotClose = () => {
    setIsBotActive(false);
    setIsBotconfig(false);
  };
  const handleBotStatusClose = () => {
    setIsBotStatusActive(false);
  };
  const handleBotUpdate = async () => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const data = await getUserDetails(token);
        console.log(data, "Home response here ---->>>>>", data.emailStatus);
        if (data && data.status) {
          const userDetails = {
            isAuthenticated: true,
            tfaStatus: data.tfastatus,
            email: data.email,
            displayname: data.displayname,
            country: data.country,
            uid: data.uid,
            referralCode: data.referralCode,
            selectedStrategies: data.selectedStrategies,
            referralUrl: data.referralUrl,
            botStatus: data.botStatus,
            exchanges: data.exchanges,
            botConfig: data.botConfig,
            botActivatedAt: data.botActivatedAt,
            botDeactivatedAt: data.botDeactivatedAt,
          };
          setUser(userDetails);
          setIsBotActive(true);
          setIsBotconfig(true);
          setshowBotPopup(true);
          // if(data.botConfig != null)
          // {
          //   if(data.botConfig.dailyLoss != null)
          //   {
          //     setIsBotconfig(false);
          //     setshowBotPopup(false);
          //   }
          //   else
          //   {
          //     setIsBotconfig(true);
          //     setshowBotPopup(true);
          //   }
          // }
          // else
          // {
          //   setIsBotconfig(true);
          //   setshowBotPopup(true);
          // }

          // console.log("isBotconfig===",isBotconfig)
        } else {
          setUser({
            isAuthenticated: false,
            tfaStatus: 0,
            email: null,
            uid: null,
            exchanges: [],
            selectedStrategies: [],
            botActivatedAt: null,
            botDeactivatedAt: null,
            referralCode: null,
            referralUrl: null,
            botConfig: null,
          });
          setIsBotActive(false);
          setIsBotconfig(false);
        }
      } catch (error) {
        setUser({
          isAuthenticated: false,
          tfaStatus: 0,
          email: null,
          uid: null,
          exchanges: [],
          selectedStrategies: [],
          referralCode: null,
          referralUrl: null,
          botActivatedAt: null,
          botDeactivatedAt: null,
          botConfig: null,
        });

        setIsBotActive(false);
        setIsBotconfig(false);
      }
    } else {
      setUser({
        isAuthenticated: false,
        tfaStatus: 0,
        email: null,
        uid: null,
        referralCode: null,
        selectedStrategies: [],
        referralUrl: null,
        botActivatedAt: null,
        botDeactivatedAt: null,
        botConfig: null,
      });
      setIsBotActive(false);
      setIsBotconfig(false);
    }
    setLoading(false);
  };

  const [tradeNotifications, settradeNotifications, tradeNotificationsref] =
    useState([]);

  const get_trade_notifications = async () => {
    try {
      const response = await authService.tradeNotifications();
      setpageLoader(true);

      if (response.status) {
        if (response.data.length > 0) {
          setIsBotStatusActive(true);
        }
        setpageLoader(false);
      }
    } catch (error) {
      console.error("Error fetching transactions:", error);
    }
  };

  useEffect(() => {
    let userToken = localStorage.getItem("token");
    if (userToken) {
      get_trade_notifications();
    }
  }, [0]);
const [checks, setChecks] = useState([false, false, false, false, false]);
  const [errors, setErrors] = useState([false, false, false, false, false]);

  const handleCheck = (index) => {
    const updated = [...checks];
    updated[index] = !updated[index];
    setChecks(updated);

    // remove error when checked
    if (updated[index]) {
      const err = [...errors];
      err[index] = false;
      setErrors(err);
    }
  };

  const handleSubmit =async() => {
    let newErrors = [...errors];

    checks.forEach((checked, i) => {
      if (!checked) newErrors[i] = true;
    });

    setErrors(newErrors);

    // if all true → submit logic here
    if (newErrors.every((x) => x === false)) {
      console.log("All selected — submit success");
      const status=true
        const data = await authService.riskbox(status);
       setriskpopupstatus(false);
    }
  };

  const labels = [
    t("userconfirm1"),
    t("userconfirm2"),
    t("userconfirm3"),
    t("userconfirm4"),
    t("userconfirm5")
  ];

  return (
    <div>
      <section>
        <Header />
      </section>
      <div className="home">
        <div className="container">
          {pageLoader == true ? (
            <div className="loader_main loader_mainChange">
              <ScaleLoader color="#20A1FD" height={10} width={3} />
              <p>{t("Loading")}</p>
            </div>
          ) : (
            <div className="home_main">
              {profitloading ? (
                <div className="loader_main loader_mainChange">
                  <ScaleLoader color="#20A1FD" height={10} width={3} />
                  <p>{t("Loading")}</p>
                </div>
              ) : (
                <>
                  <div className="home_first_main">
                    <div className="home_first_left">
                      <div className="home_user_main">
                        <img
                          src={require("../assests/icons/home-user.png")}
                          alt="User"
                          className="home_user_icon"
                        />
                        <div className="home_user_name">
                          <span className="home_user_display user-email-details">
                            {user.email}
                          </span>
                          <div className="home_uid_main">
                            <span className="home_user_uid">{user.uid}</span>
                            <i
                              class="ri-file-copy-line cursor-pointer uid_copy"
                              onClick={() => copyToClipboard(user.uid)}
                            ></i>
                          </div>
                        </div>
                      </div>
                      <span className="home_slash">|</span>
                      <div className="home_bln_top">
                        <div className="home_user_bln">
                          <span className="home_userbln_head">
                            {t("TotalValue(usdt)")}
                          </span>
                          <span className="footer_head">
                            {totalBalanceref.current}
                          </span>
                        </div>
                        <div className="home_user_bln">
                          <span className="home_userbln_head">
                            {t("FuelWallet")}
                          </span>
                          <span className="footer_head">{fuelWallet}</span>
                        </div>
                        <div className="home_user_bln">
                          <span className="home_userbln_head">
                            {t("TodayPNL")}
                          </span>
                          <span className="footer_head">
                            {profitData?.todayProfit
                              ? profitData?.todayProfit
                              : "0.00"}
                          </span>
                        </div>
                        <div className="home_user_bln">
                          <span className="home_userbln_head">
                            {t("YesterdayPNL")}
                          </span>
                          <span className="footer_head">
                            {profitData?.yesterdayProfit
                              ? profitData?.yesterdayProfit
                              : "0.00"}
                          </span>
                        </div>

                        {/* <div className="home_user_bln">
                    <span className="home_userbln_head">
                      Binance Balance (usdt)
                    </span>
                    <span className="footer_head">0.00</span>
                  </div> */}

                        {/* <div className="home_user_bln">
                    <span className="home_userbln_head"> 7 Days Pnl</span>
                    <span className="footer_head">0.00%</span>
                  </div> */}
                        <div className="home_user_bln">
                          <span className="home_userbln_head">
                            {" "}
                            {t("30DaysPNL")}
                          </span>
                          <span className="footer_head">
                            {profitData?.monthlyProfit
                              ? profitData?.monthlyProfit
                              : "0.00"}
                          </span>
                        </div>
                        <div className="home_user_bln">
                          <span className="home_userbln_head">
                            {" "}
                            {t("OverallPNL")}
                          </span>
                          <span className="footer_head">
                            {profitData?.overallProfit
                              ? profitData?.overallProfit
                              : "0.00"}
                          </span>
                        </div>
                      </div>
                    </div>
                    <Link to="/assets">
                      <div className="dash_first_right">
                        <img
                          src={require("../assests/icons/home-assest-view.png")}
                          alt="View Asset"
                          className="home_viewasset_img"
                        />
                        <span className="home-viewasset-span">
                          {t("ViewAssets")}
                        </span>
                      </div>
                    </Link>
                  </div>
                </>
              )}
              <div className="row mt-4">
                <div className="col-lg-8">
                  <div className="h-100">
                    <img
                      src={require("../assests/home-banner.webp")}
                      alt="Trading Bot"
                      className="home_second_img"
                    />
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="home_second_rightmain">
                    <div className="manage_btn_row">
                      <span className="home_botstatus_span">
                        {t("BotStatus")}
                      </span>

                      <div className="home_bottop_right">
                        {user.botStatus != "Active" ? (
                          <i
                            class="bi bi-exclamation-circle home_user_info"
                            style={{ color: "#ee516d" }}
                          ></i>
                        ) : (
                          ""
                        )}
                        {/* <i class="fa-regular fa-circle-check home_user_info_correct"></i> */}
                        {/* <span className="home_bot_inactive">
                        {" "}
                        {user.botStatus == "Active"
                          ? "Active"
                          : "In Active"}{" "}
                      </span> */}
                        {user.botStatus == "Active" ? (
                          <span className="home_bot_active">Active</span>
                        ) : (
                          <span className="home_bot_inactive">
                            {" "}
                            {t("InActive")}
                          </span>
                        )}
                      </div>
                    </div>

                    <div className="home_activate_main">
                      <div className="update_config">
                        <span className="home_botstatus_def">
                          {t("YourBotIs")}{" "}
                          {user.botStatus === "Active" ? "active" : "inactive"}.
                          <span className="bot_condition">
                            {user.botStatus === "Active"
                              ? "Deactivate"
                              : "Activate"}{" "}
                          </span>
                          {t("YourBot")}
                        </span>

                        {/* Bot settings */}
                        {/* {user?.botConfig &&
                          user.botConfig.maxLimit &&
                          user.botConfig.maxOpen &&
                          user.botConfig.dailyLoss &&
                          user.botConfig.lotPercentage &&
                          user.botConfig.selectedOption &&
                          user.botConfig.pairSelection &&
                          user.botConfig.pairSelection.length > 0 && ( */}
                        <span
                          className="update_iconconfig"
                          onClick={handleBotUpdate}
                        >
                          <FcDataConfiguration />
                        </span>
                        {/* // )} */}
                      </div>

                      {/* {user.botStatus === "Active" ? (
                        StratagyLoader ? (
                          <div className="invest_main">
                            <span className="invest_now">{t("Loading1")}</span>
                            <span className="invest_new">{t("Loading1")}</span>
                          </div>
                        ) : (
                          <div
                            className="invest_main"
                            onClick={() => updateUserBotStatus("DeActive")}
                          >
                            <span className="invest_now">
                              {t("Deactivate")}
                            </span>
                            <span className="invest_new">
                              {t("Deactivate")}
                            </span>
                          </div>
                        )
                      ) : StratagyLoader ? (
                        <div className="invest_main">
                          <span className="invest_now">{t("Loading1")}</span>
                          <span className="invest_new">{t("Loading1")}</span>
                        </div>
                      ) : (
                        <div
                          className="invest_main"
                          onClick={() => updateUserBotStatus("Active")}
                        >
                          <span className="invest_now">{t("Activate")}</span>
                          <span className="invest_new">{t("Activate")}</span>
                        </div>
                      )}
                 */}

                      {/* new  */}

                      <>
                        {StratagyLoader ? (
                          <div className="invest_main">
                            <span className="invest_now">{t("Loading1")}</span>
                            <span className="invest_new">{t("Loading1")}</span>
                          </div>
                        ) : (
                          <div className="invest_main" onClick={handleBotOpen}>
                            {user.botStatus === "Active" ? (
                              <>{t("Deactivate")}</>
                            ) : (
                              <>{t("Activate")}</>
                            )}
                          </div>
                        )}
                      </>
                      {/* <button className="invest_main" onClick={()=> {
                        setIsBotStatusActive(true)
                      }} >Bot Status</button> */}

                      {user.botStatus === "Active" && user.botActivatedAt && (
                        <p className="home_botstatus_def">
                          {t("Activated")}:{" "}
                          {formatDateTime(user.botActivatedAt)}
                        </p>
                      )}

                      {user.botStatus === "DeActive" &&
                        user.botDeactivatedAt && (
                          <p className="home_botstatus_def">
                            {t("LastDeactivated")}:{" "}
                            {formatDateTime(user.botDeactivatedAt)}
                          </p>
                        )}

                      {planDetailsBot.length > 0 ? (
                        <p className="home_botstatus_def">
                          {t("SubscriptionExpireDate")}:{" "}
                          {formatDateTime(
                            planDetailsBot[0].subscriptionEndDate
                          )}
                        </p>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row mt-4 mb-4">
                <div className="col-lg-8">
                  <div className="home_third_left">
                    <div className="home_third_topmain">
                      <div className="manage_btn_row">
                        <div
                          className="home_botstatus_span"
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            flexWrap: "wrap",
                            gap: "20px",
                            fontSize: "16px",
                          }}
                        >
                          <strong style={{ marginRight: "15px" }}>
                            {t("Top strategies")}
                          </strong>
                        </div>

                        <div className="scroll-controls">
                          {showLeftArrow && (
                            <i
                              className="fa-solid fa-chevron-left scroll-arrow left-arrow"
                              onClick={scrollLeft}
                            ></i>
                          )}
                          {showRightArrow && (
                            <i
                              className="fa-solid fa-chevron-right scroll-arrow right-arrow"
                              onClick={scrollRight}
                            ></i>
                          )}
                        </div>
                      </div>

                      {loader ? (
                        <div className="loader_main loader_mainChange">
                          <ScaleLoader color="#20A1FD" height={10} width={3} />
                          <p>{t("Loading")}</p>
                        </div>
                      ) : (
                        <>
                          <div className="row">
                            {strategyList
                              .filter((options) => {
                                if (selectedStrategies.length === 0)
                                  return true;
                                return selectedStrategies.includes(
                                  options.stratagyName
                                );
                              })
                              .slice(
                                visibleStartIndex,
                                visibleStartIndex + cardsToShow
                              )
                              .map((options) => {
                                const seriesData =
                                  state.series.find(
                                    (s) => s.name === options.stratagyName
                                  ) || null;

                                return (
                                  <div
                                    className="col-lg-4 card-2SEqCpTf-"
                                    key={options._id}
                                  >
                                    <div
                                      className="home_topstarty_inmain"
                                      // className={`home_topstarty_inmain ${
                                      //   planDetails?.includes(
                                      //     options.stratagyName
                                      //   )
                                      //     ? "active"
                                      //     : "home_topstarty_inmainactive"
                                      // }`}
                                    >
                                      <div className="home_topstary_inntop w-100">
                                        <img
                                          src={require("../assests/home_profit2.png")}
                                          className="hme_profit_img"
                                        />
                                        <div className="top_startgy_intopintop">
                                          <div className="newsra_po_chn nw_jc_start">
                                            <span className="dca_main intra_main">
                                              {options.stratagyName}
                                            </span>
                                            <i
                                              className="fa-regular fa-circle-question"
                                              onClick={() => openModal(options)}
                                            ></i>
                                          </div>
                                          <div className="reg_check_main">
                                            <img
                                              src={require("../assests/icons/topstartegy-users.png")}
                                              alt="Users"
                                              className="topstartegy-users intra_strgy_users"
                                            />
                                            <span className="top-99 strg_count">
                                              {options.strategy_count}
                                            </span>
                                          </div>
                                        </div>
                                        <div className="top_startgy_intopinbottom">
                                          <div className="top_startgy_inbottomlefthome">
                                            {/* <span className="top_startgy_inbottomadvance">
                                              {t("MonthlyROI")}
                                            </span> */}
                                            {/* <span className="hme_up_icon">
                                            </span> */}
                                            {/* <span className="top_startgy_inbottompercen">
                                              {options.profit_percentage}%
                                            </span> */}
                                          </div>
                                          {/* <div
                                            id="chart"
                                            className="chart_mainhome mx-2"
                                          >
                                            <ReactApexChart
                                              options={state.options}
                                              series={
                                                seriesData ? [seriesData] : []
                                              }
                                              type="area"
                                              height={130}
                                            />
                                          </div> */}
                                        </div>
                                      </div>

                                      <span
                                        className={`home_check_wrap ${
                                          user?.selectedStrategies?.includes(
                                            options.stratagyName
                                          )
                                            ? "active"
                                            : ""
                                        }`}
                                      >
                                        <input
                                          type="checkbox"
                                          className="home_checkbox"
                                          checked={user?.selectedStrategies?.includes(
                                            options.stratagyName
                                          )}
                                          onChange={() =>
                                            handleStrategyClick(
                                              options.stratagyName
                                            )
                                          }
                                        />
                                      </span>
                                    </div>
                                  </div>
                                );
                              })}
                          </div>
                          <div className="home_third_topmain pb-0">
                            <div className="manage_btn_row">
                              <span className="home-viewasset-span">
                                {" "}
                                {t("RecentDeposit")}
                              </span>
                              <Link to="/allhistory">
                                <div className="d-flex align-items-center gap-2 cursor-pointer viewall_stragies">
                                  <span className="home_starty_view">
                                    {t("ViewAll")}
                                  </span>
                                  <i class="fa-solid fa-chevron-right home_starty_viewarrow"></i>
                                </div>
                              </Link>
                            </div>
                            <div className="recent_depo_tablemain pb-0">
                              <div className="table-responsive table-borderless home_recent_table">
                                {loading ? (
                                  <div className="loader_main loader_mainChange">
                                    <ScaleLoader
                                      color="#20A1FD"
                                      height={10}
                                      width={3}
                                    />
                                    <p>{t("Loading")}</p>
                                  </div>
                                ) : (
                                  <table className="table">
                                    <thead>
                                      <tr>
                                        <th className="text_left">
                                          {t("Currency")}
                                        </th>
                                        <th>{t("Date&Time")}</th>
                                        <th>{t("Network")}</th>
                                        <th>{t("Amount")}</th>
                                        <th>{t("TransactionID")}</th>
                                      </tr>
                                    </thead>

                                    <tbody>
                                      {transactions.length > 0 ? (
                                        transactions
                                          .slice(0, 5)
                                          .map((transaction, index) => (
                                            <tr key={index}>
                                              <td>
                                                <div className="home_recent_firstdata">
                                                  <img
                                                    src={
                                                      transaction.currency ===
                                                      "usdt"
                                                        ? require("../assests/usdt-logo.png")
                                                        : transaction.currency ===
                                                          "usdt"
                                                        ? require("../assests/usdt-logo.png")
                                                        : require("../assests/usdt-logo.png")
                                                    }
                                                    alt={transaction.currency}
                                                    className="usdt_home_recent"
                                                  />
                                                  <span>
                                                    {transaction.currency}
                                                  </span>
                                                </div>
                                              </td>
                                              <td>
                                                <span>
                                                  {isNaN(
                                                    new Date(transaction.date)
                                                  )
                                                    ? "null"
                                                    : dayjs(
                                                        transaction.date
                                                      ).format(
                                                        "DD MMMM YYYY, hh:mm A"
                                                      )}
                                                </span>
                                              </td>
                                              <td>
                                                <span>
                                                  {transaction.network}
                                                </span>
                                              </td>
                                              <td>
                                                <span>
                                                  {transaction.amount}
                                                </span>
                                              </td>
                                              <td>
                                                <div className="home_uid_main">
                                                  <span>
                                                    {transaction.transactionId}
                                                  </span>
                                                  <i
                                                    className="ri-file-copy-line cursor-pointer uid_copy_recent"
                                                    onClick={() => {
                                                      handleCopy(
                                                        transaction.transactionId
                                                      );
                                                    }}
                                                  ></i>
                                                </div>
                                              </td>
                                            </tr>
                                          ))
                                      ) : (
                                        <tr>
                                          <td colSpan="5">
                                            <span className="depo_no_record">
                                              {t("NoTransactionsFound")}
                                            </span>
                                          </td>
                                        </tr>
                                      )}
                                    </tbody>
                                  </table>
                                )}
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="home_third_topmain home_mrkt_price_wrp mb-2">
                    <span className="home_right_marketspan">
                      {t("MarketPrices")}
                    </span>
                    <div className="table-responsive table-borderless home_recent_table">
                      <table className="table">
                        <thead>
                          <tr>
                            {" "}
                            {/* Wrap the headers inside a <tr> */}
                            <th className="text_left">{t("Name")}</th>
                            <th>{t("Price")}</th>
                            <th>{t("Change")}</th>
                          </tr>
                        </thead>

                        {marketLoader ? (
                          <tbody>
                            <tr>
                              <td colSpan={3} style={{ textAlign: "center" }}>
                                <div className="loader_main loader_mainChange">
                                  <ScaleLoader
                                    color="#20A1FD"
                                    height={10}
                                    width={3}
                                  />
                                  <p>{t("Loading")}</p>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        ) : marketDataref.current.length > 0 ? (
                          <tbody>
                            {marketDataref.current
                              .slice(0, 7)
                              .map((options, index) => (
                                <tr key={index}>
                                  <td>
                                    <div className="home_recent_firstdata">
                                      <img
                                        // src={options.imageUrl}
                                        src={require(`../assests/coins/${options.symbol.toLowerCase()}.png`)}
                                        alt={options.symbol}
                                        className="usdt_home_recent"
                                      />
                                      <span> {options.symbol}</span>
                                    </div>
                                  </td>
                                  <td>
                                    <div className="home_market_center">
                                      <span> {options.price}</span>
                                      {/* <span className="home_market_center_dim">${options.Usdprice}</span> */}
                                    </div>
                                  </td>
                                  <td>
                                    <span
                                      className={
                                        options.change24Hour > 0
                                          ? "home_market_lastdata"
                                          : "home_market_lastdatared"
                                      }
                                    >
                                      {options.change24Hour}%
                                    </span>
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        ) : (
                          <tbody>
                            <tr>
                              <td colSpan={3} style={{ textAlign: "center" }}>
                                {t("NoDataAvailable")}
                              </td>
                            </tr>
                          </tbody>
                        )}
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div className="home_third_topmain home_bot_hsrty_wrp">
                  <div className="home_bot_tbl_topwrp">
                    <span className="home_right_marketspan">
                      {t("BotTradeHistory")}
                    </span>

                    <div className="home_bot_dateWrp">

                      <div className="home_bot_SearchWrp">
                          <input
                            className="home_bot_Search"
                            ref={inputRef}
                            placeholder="Search"
                            value={filterKeyword}
                            onChange={(e) => {
                              const value = e.target.value;
                              console.log(value, "value");
                              if (value.length === 1 && value.startsWith(" "))
                                return;
                              setFilterKeyword(value);
                            }}
                            // onChange={handleFilterChange}
                          />
                          <i className="fa-solid fa-magnifying-glass"></i>
                        </div>


                      <FromDatePicker
                          placeholder="DD-MM-YYYY"
                          onSearch={(date) => setFromDate(date)}
                        />
                        <ToDatePicker
                          placeholder="DD-MM-YYYY"
                          fromDate={fromDate}
                          onSearch={(date) => setToDate(date)}
                        />
                        
                        <button className="invest_main home_bot_filter" onClick={()=>{ fetchbottradeHistory(currentPagebtrade, limitbtrade,fromDate,toDate,filterKeyword);}}>Filter <FaFilter /></button>

                       {CSVfile.length >0 ?
                 <button onClick={download_csv} className="invest_main home_bot_export d-flex">
                 <CsvDownloader text="Download" className="d-flex" filename="Profit History" extension=".csv"  datas={CSVfile}> 
                 Export  <i class="fa fa-download"aria-hidden="true"></i></CsvDownloader>
                 </button>
                :""
                } 
                      {/* <button className="invest_main home_bot_export" >Export <i
                        className="fa fa-download"
                        aria-hidden="true"
                      ></i> </button> */}

                        
                    </div>
                  </div>
                  <div className="secuirty_box_contentsub deposit_contentsub">
                    <div className="table_section home_recent_table">
                      <div
                        className="table_boxcontainer"
                        style={{ height: "max-content" }}
                      >
                        <table>
                          <thead>
                            <tr>
                              <th>{t("Exchange")}</th>
                              <th>{t("Currency")}</th>
                              <th>{t("Profit")}</th>
                              <th>{t("Strategy")}</th>
                              <th>{t("Date&Time")}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {botLoader ? (
                              <tr>
                                <td
                                  colSpan="5"
                                  style={{
                                    textAlign: "center",
                                    padding: "20px",
                                  }}
                                >
                                  <div className="loader_main loader_mainChange">
                                    <ScaleLoader
                                      color="#20A1FD"
                                      height={10}
                                      width={3}
                                    />
                                    <p>{t("Loading")}</p>
                                  </div>
                                </td>
                              </tr>
                            ) : bottradeHistory.length > 0 ? (
                              bottradeHistory.map((ticket) => (
                                <tr key={ticket._id}>
                                  <td>{ticket.exchange}</td>
                                  <td>{ticket.currency}</td>
                                  <td>{ticket.userProfit}</td>
                                  <td>{ticket.stratagy}</td>
                                  <td>
                                    {new Date(
                                      ticket.createdDate
                                    ).toLocaleString()}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td
                                  colSpan="5"
                                  style={{ textAlign: "center" }}
                                >
                                  <span className="depo_no_record">
                                    {t("NoBotTradeFound")}
                                  </span>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                        {totalPagesbtrade > 1 && (
                          <div className="pagination history_pagination_all">
                            <Stack spacing={2}>
                              <Pagination
                                count={totalPagesbtrade}
                                page={currentPagebtrade}
                                onChange={(e, value) =>
                                  handlePageChange(
                                    e,
                                    value,
                                    "Bot Trade"
                                  )
                                }
                                size="small"
                                sx={{
                                  "& .MuiPaginationItem-root": {
                                    color: "#fff",
                                  },
                                  "& .Mui-selected": {
                                    backgroundColor:
                                      "#ffc630 !important",
                                    color: "#000",
                                    "&:hover": {
                                      backgroundColor: "#ffc630",
                                      color: "#000",
                                    },
                                  },
                                  "& .MuiPaginationItem-ellipsis": {
                                    color: "#fff",
                                  },
                                  "& .MuiPaginationItem-icon": {
                                    color: "#fff",
                                  },
                                }}
                              />
                            </Stack>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
              </div>

              <section className="footer_section">
                <div className="container">
                  <section className="row mx-0 bn-footer-row g-4 g-lg-1">
                    <div className="col-lg-6 col-sm-6 col-12">
                      <div>
                        <img
                          src={require("./img/footer-logo.webp")}
                          alt=""
                          className="bn-footer-logo"
                        />
                        <p className="bn-footer-logo-content">{t("Powered")}</p>
                      </div>
                    </div>
                    <div className="col-lg-2 col-sm-4 col-6">
                      <h6 className="bn-footer-link-title">{t("Explore")}</h6>
                      <ul className="bn-footer-lists">
                        {/* <li>
                          <Link to="/" className="bn-footer-links">
                            Newbies
                          </Link>
                        </li>
                        <li>
                          <Link to="/" className="bn-footer-links">
                            Knowledge Base
                          </Link>
                        </li>
                        <li>
                          <Link to="/" className="bn-footer-links">
                            Strategies
                          </Link>
                        </li> */}
                        <li>
                          <Link
                            to="/termscondition"
                            className="bn-footer-links"
                          >
                            {t("TermsAndService")}
                          </Link>
                        </li>
                        <li>
                          <Link to="/privacypolicy" className="bn-footer-links">
                            {t("PrivacyPolicy")}
                          </Link>
                        </li>
                      </ul>
                    </div>

                    <div className="col-lg-2 col-sm-6 col-6">
                      <h6 className="bn-footer-link-title">{t("Support")}</h6>
                      <ul className="bn-footer-lists">
                        {/* <li>
                    <Link to="/" className="bn-footer-links">
                      Terms & Conditions
                    </Link>
                  </li>
                  <li>
                    <Link to="/" className="bn-footer-links">
                      Privacy Policy
                    </Link>
                  </li> */}
                        <li>
                          <Link to="/support" className="bn-footer-links">
                            {t("HelpCenter")}
                          </Link>
                        </li>
                      </ul>
                    </div>
                    <div className="col-lg-2 col-sm-6 col-6">
                      <h6 className="bn-footer-link-title">{t("Social")}</h6>
                      <ul className="bn-footer-icon-wrap">
                        <li>
                          <a target="_blank" href={siteDatacomes.instagram}>
                            <img src={require("./img/instagram.webp")} alt="" />
                          </a>
                        </li>
                        <li>
                          <a target="_blank" href={siteDatacomes.twitter}>
                            <img src={require("./img/x.webp")} alt="" />
                          </a>
                        </li>
                        <li>
                          <a target="_blank" href={siteDatacomes.telegram}>
                            <img src={require("./img/telegram.webp")} alt="" />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </section>
                </div>
              </section>

              {isModalOpen && (
                <div
                  className="modal fade show"
                  style={{ display: "block" }}
                  tabIndex="-1"
                  role="dialog"
                >
                  <div class="modal-dialog modal-dialog-centered modal-md">
                    <div class="modal-content">
                      <div class="modal-header lvl-one-header">
                        <h1 class="modal-title fs-5" id="exampleModalLabel">
                          <span className="home_user_display">
                            {/* <img
                              src={require("../assests/icons/account-details.png")}
                              alt="Acount details"
                              className="profile_subheads_logo mb-1 mx-2"
                            />{" "} */}
                            {t("StrategyDetails")}
                          </span>
                        </h1>
                        <button
                          type="button"
                          class="btn-close btn-close-custom nestra_poo_hea"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                          onClick={() => handleModalclose()}
                        ></button>
                      </div>
                      <div className="modal-body personal_verify_body lvl-one-body">
                        <div className="mt-2 d-flex flex-column gap-3">
                          <div className="profile_edit_inpmain">
                            <span className="home-viewasset-span">
                              <span>{t("MinimumExchangesRequired")} :</span>{" "}
                              {strategyDetails.min_exchange}
                            </span>
                          </div>
                          <div className="profile_edit_inpmain">
                            <span className="home-viewasset-span">
                              <span>{t("MinimumDepositRequired")} :</span>{" "}
                              {strategyDetails.min_deposit} {t("usdt")}
                            </span>
                          </div>
                          <div className="profile_edit_inpmain">
                            <span className="home-viewasset-span">
                              <span>
                                {ToastContainer} {t("MinimumFuelRequired")} :
                              </span>{" "}
                              {strategyDetails.min_fuel} {t("usdt")}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {showBotPopupref.current ? (
                <Modal
                  open={isBotActive}
                  onClose={handleBotClose}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box sx={style} className="bot_modal_box">
                    <BotPopup
                      handleBotClose={handleBotClose}
                      isBotconfig={isBotconfigref.current}
                      userDetails={user}
                    />
                  </Box>
                </Modal>
              ) : (
                ""
              )}

              {riskpopupstatus ? (
                <Modal
                  open={riskpopupstatus}
                  onClose={() => {
                    setriskpopupstatus(false);
                  }}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box sx={style} className="bot_modal_box">
                    <div className="bot_modal_head">
                      <h4>{t("riskHead")}</h4>

                      <span
                       onClick={() => {
                    setriskpopupstatus(false);
                  }}
                        className="bot_modal_close"
                      >
                        <i class="fa-regular fa-circle-xmark"></i>
                      </span>
                    </div>

                    <div className="bot_modal_body fixheight">
                      <div>
                        <label htmlFor="max-limit" className="bot_modal_label">
                          {t("risklastDate")}
                        </label>
                        <p>{t("riskContentfirst")}</p>
                        <p>{t("riskContentsecondt")}</p>
                      </div>
                      <hr />
                      <div>
                        <h3>{t("MarketRisk")}</h3>
                        <p>{t("MarketContentfirst")}</p>
                        <p>{t("MarketContentsecond")}</p>
                        <ul>
  {t("MarketContentsecond1") && <li>{t("MarketContentsecond1")}</li>}
  {t("MarketContentsecond2") && <li>{t("MarketContentsecond2")}</li>}
  {t("MarketContentsecond3") && <li>{t("MarketContentsecond3")}</li>}
</ul>

                        <p>{t("MarketContentsecond1")}</p>
                      </div>
                      <hr />
                      <div>
                        <h3>{t("ATRRisk")}</h3>
                        <p>{t("MarketCoATRfirstntentfirst")}</p>
                        <ul>
                          {t("ATR1") && <li>{t("ATR1")}</li>}
                          {t("ATR2") && <li>{t("ATR2")}</li>}
                          {t("ATR3") && <li>{t("ATR3")}</li>}
                          {t("ATR4") && <li>{t("ATR4")}</li>}
                          {t("ATR5") && <li>{t("ATR5")}</li>}
                          {t("ATR6") && <li>{t("ATR6")}</li>}
                        </ul>
                        <p>{t("ATR7")}</p>
                      </div>
                      <hr />
                      <div>
                        <h3>{t("NoncustodialRisk")}</h3>
                        <p>{t("Noncustodialfirst")}</p>
                        <p>{t("Noncustodialsecond")}</p>
                        <ul>
                          <li>{t("Noncustodial1")}</li>
                          <li>{t("Noncustodial2")}</li>
                          <li>{t("Noncustodial3")}</li>
                          <li>{t("Noncustodial4")}</li>
                        </ul>
                        <p>{t("Noncustodial5")}</p>
                      </div>
                      <hr />
                      <div>
                        <h3>{t("exchangeRisk")}</h3>
                        <p>{t("exchangefirst")}</p>
                        <p>{t("exchangesecond")}</p>
                        <ul>
                          {t("exchange1") && <li>{t("exchange1")}</li>}
                          {t("exchange2") && <li>{t("exchange2")}</li>}
                          {t("exchange3") && <li>{t("exchange3")}</li>}
                          {t("exchange4") && <li>{t("exchange4")}</li>}
                          {t("exchange5") && <li>{t("exchange5")}</li>}
                        </ul>
                        <p>{t("exchange6")}</p>
                      </div>
                      <hr />
                      <div>
                        <h3>{t("technicalRisk")}</h3>
                        <p>{t("technicalfirst")}</p>
                        <p>{t("technicalsecond")}</p>
                        <ul>
                          {t("technical1")&&<li>{t("technical1")}</li>}
                          {t("technical2")&&<li>{t("technical2")}</li>}
                          {t("technical3")&&<li>{t("technical3")}</li>}
                          {t("technical4")&&<li>{t("technical4")}</li>}
                          {t("technical5")&&<li>{t("technical5")}</li>}
                        </ul>
                        <p>{t("technical6")}</p>
                      </div>
                      <hr />
                      <div>
                        <h3>{t("technicalRisk")}</h3>
                        <p>{t("technicalfirst")}</p>
                        <p>{t("technicalsecond")}</p>
                        <ul>
                          {t("technical1") && <li>{t("technical1")}</li>}
                          {t("technical2") && <li>{t("technical2")}</li>}
                          {t("technical3") && <li>{t("technical3")}</li>}
                          {t("technical4") && <li>{t("technical4")}</li>}
                          {t("technical5") && <li>{t("technical5")}</li>}
                        </ul>
                        <p>{t("technical6")}</p>
                      </div>
                      <hr />
                      <div>
                        <h3>{t("policypacklimit")}</h3>
                        <p>{t("policypacklimitfirst")}</p>
                        <ul>
                          {t("policypack1") && <li>{t("policypack1")}</li>}
                          {t("policypack2") && <li>{t("policypack2")}</li>}
                          {t("policypack3") && <li>{t("policypack3")}</li>}
                          {t("policypack4") && <li>{t("policypack4")}</li>}
                          {t("policypack5") && <li>{t("policypack5")}</li>}
                          {t("policypack6") && <li>{t("policypack6")}</li>}
                        </ul>
                        <p>{t("policypacklimitsecond")}</p>
                        <p>{t("policypacklimitsecond1")}</p>
                        <p>{t("policypacklimitsecond2")}</p>
                        <p>{t("policypacklimitsecond3")}</p>
                      </div>
                      <hr />
                      <div>
                        <h3>{t("profitshareRisk")}</h3>
                        <ul>
                          {t("profitshare1") && <li>{t("profitshare1")}</li>}
                          {t("profitshare2") && <li>{t("profitshare2")}</li>}
                        </ul>
                        <p>{t("profitsharelimitsecond")}</p>
                        <p>{t("profitsharelimitsecond1")}</p>
                        <p>{t("profitsharelimitsecond2")}</p>
                        <p>{t("profitsharelimitsecond3")}</p>
                      </div>
                      <hr />
                      <div>
                        <h3>{t("LiquidityRisk")}</h3>
                        <p>{t("Liquiditylimitfirst")}</p>
                        <p>{t("Liquiditylimitsecond")}</p>
                        <ul>
                          {t("Liquidity1") && <li>{t("Liquidity1")}</li>}
                          {t("Liquidity2") && <li>{t("Liquidity2")}</li>}
                          {t("Liquidity3") && <li>{t("Liquidity3")}</li>}
                        </ul>
                        <p>{t("Liquidity4")}</p>
                      </div>
                      <hr />
                      <div>
                        <h3>{t("Noinvestment")}</h3>
                        <p>{t("Noinvestmentfirst")}</p>
                        <p>{t("Liquiditylimitsecond")}</p>
                        <ul>
                          {t("Noinvestment1")&&<li>{t("Noinvestment1")}</li>}
                          {t("Noinvestment2")&&<li>{t("Noinvestment2")}</li>}
                          {t("Noinvestment3")&&<li>{t("Noinvestment3")}</li>}
                        </ul>
                        <p>{t("Noinvestment4")}</p>
                      </div>
                      <hr />
                      <div>
                        <h3>{t("Noinvestment")}</h3>
                        <p>{t("Noinvestmentfirst")}</p>
                        <p>{t("Liquiditylimitsecond")}</p>
                        <ul>
                          {t("Noinvestment1") &&<li>{t("Noinvestment1")}</li>}
                          {t("Noinvestment2") &&<li>{t("Noinvestment2")}</li>}
                          {t("Noinvestment3") &&<li>{t("Noinvestment3")}</li>}
                        </ul>
                        <p>{t("Noinvestment4")}</p>
                      </div>
                      <hr />
                      <div>
                        <h3>{t("responsibility")}</h3>
                        <p>{t("responsibilityfirst")}</p>
                        <ul>
                          {t("responsibility1") && <li>{t("responsibility1")}</li>}
                          {t("responsibility2") && <li>{t("responsibility2")}</li>}
                          {t("responsibility3") && <li>{t("responsibility3")}</li>}
                          {t("responsibility4") && <li>{t("responsibility4")}</li>}
                          {t("responsibility5") && <li>{t("responsibility5")}</li>}
                          {t("responsibility6") && <li>{t("responsibility6")}</li>}
                        </ul>
                      </div>
                      <hr />
                      <div>
                        <h3>{t("Guarantees")}</h3>
                        <p>{t("Guaranteesfirst")}</p>
                        <p>{t("Guaranteessecond")}</p>
                      </div>
                      <hr />

                      <div>
                        {" "}
                        <h3>{t("userconfirm")}</h3>
                        {/* <div className="d-flex p-2">
                          <input type="checkbox" />
                          <span className="m-2">{t("userconfirm1")}</span>
                        </div>
                        <div className="d-flex p-2">
                          <input type="checkbox" />
                          <span className="m-2">{t("userconfirm2")}</span>
                        </div>
                        <div className="d-flex p-2">
                          <input type="checkbox" />
                          <span className="m-2">{t("userconfirm3")}</span>
                        </div>
                        <div className="d-flex p-2">
                          <input type="checkbox" />
                          <span className="m-2">{t("userconfirm4")}</span>
                        </div>
                        <div className="d-flex p-2">
                          <input type="checkbox" />
                          <span className="m-2">{t("userconfirm5")}</span>
                        </div> */}
                        {labels.map((label, i) => (
        <div className="p-2" key={i}>
          <div className="d-flex">
            <input
              type="checkbox"
              checked={checks[i]}
              onChange={() => handleCheck(i)}
            />
            <span className="m-2">{label}</span>
          </div>
          {errors[i] && (
            <p style={{ color: "red", marginLeft: "25px", marginTop: "4px" }}>
              {t("please_check_this_box") || "Please check this box"}
            </p>
          )}
        </div>
      ))}
                      </div>
                      <div className="bot_mdl_btn_wrap">
                        <button className="bot_mdl_btn" onClick={() => {
                    setriskpopupstatus(false);
                  }}>{t("next")}</button>
                        <button className="bot_mdl_btn" onClick={handleSubmit}>{t("Confirm")}</button>
                      </div>
                    </div>
                  </Box>
                </Modal>
              ) : (
                ""
              )}
              {/* {emailPopup && (
                <div
                  className="modal fade show email_modal"
                  style={{ display: "block" }}
                  tabIndex="-1"
                  role="dialog"
                >
                  <div
                    className="modal-dialog modal-dialog-centered modal-md"
                    role="document"
                  >
                    <div className="modal-content">
                      <div className="modal-header lvl-one-header email_missing_header">
                        <h1 className="modal-title fs-5" id="exampleModalLabel">
                          Email Update
                        </h1>

                        <span className="btn-close-new" onClick={closePopup}>
                          X
                        </span>
                      </div>
                      <div className="modal-body personal_verify_body lvl-one-body email_missing_header">
                        <div className="mt-2 d-flex flex-column gap-3">
                          <div className="profile_edit_inpmain">
                            <span className="home-viewasset-span">
                              <h1 className="email_header">
                                Your email is missing
                              </h1>
                              <p>
                                We noticed that your email is missing from your
                                account. please update your email.
                              </p>
                              <p>
                                Click the button below to update your email
                                address:
                              </p>
                            </span>
                          </div>
                          <div className="update-email">
                            <button
                              className="btn profile_savebtn"
                              onClick={proceedToProfile}
                            >
                              Update Email
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}  */}

              {/* {verifyEmailPopup && (
                <div
                  className="modal fade show email_modal"
                  style={{ display: "block" }}
                  tabIndex="-1"
                  role="dialog"
                >
                  <div
                    className="modal-dialog modal-dialog-centered modal-md"
                    role="document"
                  >
                    <div className="modal-content">
                      <div className="modal-header lvl-one-header email_missing_header">
                        <h1 className="modal-title fs-5">Verify Your Email</h1>
                        <span
                          className="btn-close-new"
                          onClick={closeVerifyPopup}
                        >
                          X
                        </span>
                      </div>
                      <div className="modal-body personal_verify_body lvl-one-body email_missing_header">
                        <div className="mt-2 d-flex flex-column gap-3">
                          <div className="profile_edit_inpmain">
                            <span className="home-viewasset-span">
                              <h1 className="email_header">
                                Your email is not verified
                              </h1>
                              <p>
                                We noticed that your email is not verified in
                                your account. please verify your email.
                              </p>
                              <p>
                                Click the button below to verify your email
                                address:
                              </p>
                            </span>
                          </div>
                          <div className="update-email">
                            <button
                              className="btn profile_savebtn"
                              onClick={proceedToProfile}
                            >
                              Verify Email
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )} */}

              {/* <Joyride
                steps={steps}
                run={run}
                continuous={true}
                showProgress={true}
                showSkipButton={true}
                showBackButton={true}
                callback={(data) => {
                  if (data.status === "finished" || data.status === "skipped") {
                    setRun(false);
                    localStorage.removeItem("userlogin"); // Remove userlogin flag after tour

                    // After Joyride finishes, check email popup condition
                    const userEmail = localStorage.getItem("useremail") || "";
                    const hasSeenEmailPopup =
                      localStorage.getItem("hasSeenEmailPopup");
                    if (!userEmail || userEmail === "N/A") {
                      setEmailPopup(true);
                      localStorage.setItem("hasSeenEmailPopup", "true");
                    }
                  }
                }}
                locale={{
                  last: "Done",
                  next: "Next",
                  back: "Back",
                  skip: "Skip",
                }}
                styles={{
                  options: {
                    zIndex: 1000,
                    primaryColor: "#007bff",
                    textColor: "#333",
                    overlayColor: "rgba(0, 0, 0, 0.5)",
                    backgroundColor: "#fff",
                    width: 400,
                  },
                  buttonSkip: {
                    backgroundColor: "transparent", // No background
                    color: "rgb(206, 179, 8)", // Yellowish color for skip button
                    fontWeight: "bold",
                    fontSize: "14px",
                    border: "none",
                    padding: "6px 12px",
                  },
                  buttonNext: {
                    backgroundColor: "#fff", // White background for next button
                    color: "#000", // Black text color
                    borderRadius: "5px",
                    fontSize: "14px",
                    padding: "8px 10px",
                    border: "1px solid #ccc",
                  },
                  buttonBack: {
                    backgroundColor: "transparent", // No background for back button
                    color: "rgb(206, 179, 8)", // Same color as skip button
                    fontWeight: "bold",
                    border: "none",
                    padding: "6px 12px",
                    fontSize: "14px",
                  },
                  tooltip: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "10px",
                  },
                  tooltipFooter: {
                    display: "flex",
                    justifyContent: "space-between", // Separates buttons
                    width: "100%",
                  },
                  buttonClose: {
                    color: "#eaecef",
                  },
                }}
              /> */}

              <Modal
                open={isBotStatusActive}
                onClose={handleBotStatusClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box sx={style} className="bot_modal_box bot_modal_boxnew">
                  <BotstatusPopup handleBotClose={handleBotStatusClose} />
                </Box>
              </Modal>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Home;
